import { store } from '../store/store.js'

export default class InitMeganav {
  constructor() {
    if ($('.meganav').length) {
      this.setListeners()
    }
  }

  setListeners() {
    let _this = this
    $('.meganav__main--link').on('click', this.handleMainLinkClick)
    $('.meganav__links--expand').on('click', this.toggleLinksExpand)
    $(document).on('click', event => {
      this.handleClick(event.target)
    })
    $(window).on('scroll', this.handleScroll)
    $(window).on('load', function () {
      setTimeout(function () {
        _this.setHeaderHeight()
      }, 0)
    })
    $(window).on('resize', this.setHeaderHeight())
  }

  setHeaderHeight() {
    $('.meganav').css('height', $('.meganav').outerHeight(true))
  }

  handleMainLinkClick() {
    if ($(this).hasClass('is-active')) return $(this).removeClass('is-active')
    $('.meganav__main--link').removeClass('is-active')
    $(this).addClass('is-active')
  }

  toggleLinksExpand() {
    $(this).hasClass('is-active') ? $(this).removeClass('is-active') : $(this).addClass('is-active')
  }

  handleClick(target) {
    if (target.closest('.meganav') === null) {
      $('.meganav__main--link').removeClass('is-active')
    }
  }

  handleScroll() {
    let scrollPosition = $(window).scrollTop()
    scrollPosition > 420 && $(window).width() >= store.breakPoints.large
      ? $('.meganav__main').addClass('is-fixed')
      : $('.meganav__main').removeClass('is-fixed')
    scrollPosition > 800 && $(window).width() >= store.breakPoints.large
      ? $('.meganav__main').addClass('is-visible')
      : $('.meganav__main').removeClass('is-visible')
  }
}
